import makeToastWorker from './makeToast/makeToast.saga'

export default [...makeToastWorker]
